import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core'

export type FormFieldAffixType = 'icon' | 'text' | 'btn' | 'field'

@Component({
  selector: 'form-field-affix',
  templateUrl: './form-field-affix.component.html',
  styleUrls: ['./form-field-affix.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormFieldAffixComponent {
  @HostBinding('class.input-group-affix') isAffix = true
}
